import useAddItem from "../../../api/api-hooks/workspaces/sidebar/useAddItem";
import { useState } from "react";
import { Modal, Button } from "reactstrap";
import FolderEditor from "./FolderEditor";
import { useAtom } from "jotai";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";

const AddFolderModal = ({ open, handleClose }) => {
  const { addItem } = useAddItem();
  const [folder, setFolder] = useState(null);
  const [resetData, setResetData] = useState(false);
  const [workspaceID] = useAtom(workspaceIdAtom);

  const handleModalClose = () => {
    setResetData(true);
    handleClose();
  };

  const handleChange = (val) => setFolder(val);

  const handleAddFolder = () => {
    addItem({ ...folder, WorkspaceID: workspaceID });
    handleModalClose();
  };

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={handleClose}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          New Folder
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>

      <div className="modal-body pt-0 pb-0">
        <FolderEditor
          onChange={handleChange}
          resetData={resetData}
          setResetData={setResetData}
        />
      </div>
      <div className="modal-footer">
        <Button
          color="secondary"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          Close
        </Button>
        <Button
          color="primary"
          disabled={!folder?.Title}
          onClick={handleAddFolder}
        >
          Add
        </Button>
      </div>
    </Modal>
  );
};

export default AddFolderModal;
